import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './VacanciesList.css';
import Preloader from '../Preloader';
import ErrorMessage from '../ErrorMessage';
import { HOST } from '../../constants/Fetch';

const TagList = props => (
  <div className="vacanciesList__tags">
    {
      props.city &&
      <div className="vacancyCard__tagItem">{props.city.name}</div>
    }
    {
      props.employments &&
      props.employments.map((employment, index) => (
        <div className="vacanciesList__tagItem" key={`vacanciesList__tag-${index}`}>{employment.name}</div>
      ))
    }
    {
      props.experience &&
      props.experience.map((exp, index) => (
        <div className="vacanciesList__tagItem" key={`vacanciesList__tag-${index}`}>{exp.name}</div>
      ))
    }
    {
      props.scope_activities &&
      props.scope_activities.map((activity, index) => (
        <div className="vacanciesList__tagItem" key={`vacanciesList__tag-${index}`}>{activity.name}</div>
      ))
    }
  </div>
);
const VacancyItem = props => {
  return (
  <Link relative="path"
    to={props.isInternship ? `../internships/internship${props.item.id}` : `../vacancies/vacancy${props.item.id}`}
    className={`vacanciesList__item col colVertTablet--12 ${props.col ? 'col--' + props.col : ''}`}
  >
    {
      !props.compact &&
      <div>
        {
          (props.item.company.logo) &&
          <img className="vacanciesList__itemLogo" src={HOST + props.item.company.logo} alt={props.item.company.name} />
        }
        <div className="vacanciesList__itemCompany">{props.item.company.name}</div>
      </div>
    }
    <h3 className="vacanciesList__itemTitle">{props.item.name}</h3>
    {
      props.item.short_content ?
        <div className="vacanciesList__itemText text" dangerouslySetInnerHTML={{ __html: props.item.short_content}} /> :
        <div className="vacanciesList__itemText text" dangerouslySetInnerHTML={{ __html: props.item.preview}} />
     }
    {
      (props.item.city || props.item.employment || props.item.experience || props.item.scope_activity) &&
      <TagList employments={props.item.employment} experience={props.item.experience} scope_activities={props.item.scope_activity} city={props.showCity && props.item.city} />
    }
  </Link>
)}

class VacanciesList extends Component {
  render() {
    if (this.props.vacancies.isLoading) {
      return <Preloader/>;
    }

    if (this.props.vacancies.hasErrored) {
      return <ErrorMessage/>;
    }

    return (
      <div className="vacanciesList row">
        {
          (this.props.vacancies.count > 0) ?
          this.props.vacancies.list
          .map((item, index) => (
            <VacancyItem
              col={this.props.cols}
              compact={this.props.compact ? true : false}
              isInternship={this.props.isInternship ? true : false}
              item={item}
              showCity={this.props.vacancies.showCity}
              key={`vacanciesList__item-${index}`}
            />
          )) :
          <div className="text text--bottom24">По данному запросу вакансий нет</div>
        }
      </div>
    );
  }
}

export default VacanciesList;




// WEBPACK FOOTER //
// ./src/components/VacanciesList/index.js